// Enhances the "add all to cart" forms rendered by snippets/add-collection-to-cart.
//
// Delegated from the document rather than bound per form: the /collections page
// carries one form per collection, and delegation also survives any section
// being re-rendered by the theme editor.
//
// Without this file the forms still work — they post to /cart/add and Shopify
// redirects to the cart. Everything here is an improvement on that, never a
// requirement for it.
(function () {
  'use strict';

  var RESET_DELAY = 2500;

  function labelFor(form, key) {
    var btn = form.querySelector('[data-add-collection-btn]');
    return (btn && btn.getAttribute('data-label-' + key)) || '';
  }

  function announce(form, text) {
    var label = form.querySelector('[data-add-collection-label]');
    if (label) label.textContent = text;

    // Screen readers get the same message through a live region: the button's
    // own text changing mid-interaction isn't reliably announced.
    var status = form.querySelector('[data-add-collection-status]');
    if (status) status.textContent = text;
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[data-add-collection-btn]');
    if (btn) btn.disabled = busy;
  }

  function reset(form) {
    form.classList.remove('is-added', 'is-error');
    announce(form, labelFor(form, 'default'));
    setBusy(form, false);
  }

  function updateCartCount(count) {
    var link = document.querySelector('.header__cart');
    if (!link) return;

    var badge = link.querySelector('.header__cart-count');
    if (!badge) {
      // The badge is only rendered server-side when the cart isn't empty, so on
      // a first add there's nothing to update and it has to be created.
      badge = document.createElement('span');
      badge.className = 'header__cart-count';
      link.appendChild(badge);
    }
    badge.textContent = count;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-add-collection]');
    if (!form) return;

    var btn = form.querySelector('[data-add-collection-btn]');
    if (btn && btn.disabled) return;

    event.preventDefault();
    setBusy(form, true);
    form.classList.remove('is-error');
    announce(form, labelFor(form, 'busy'));

    var cartUrl = form.getAttribute('data-cart-url') || '/cart';

    fetch(form.action + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (body) {
          // Shopify reports a rejected line (sold out, limit reached) as a 4xx
          // with a human-readable description rather than throwing.
          if (!response.ok) {
            throw new Error(body.description || body.message || 'add failed');
          }
          return body;
        });
      })
      .then(function () {
        return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        form.classList.add('is-added');
        announce(form, labelFor(form, 'added'));

        // Tell anyone listening (assets/analytics-events.js) without coupling
        // this file to any tracking vendor.
        form.dispatchEvent(new CustomEvent('forge-fyre:collection-added', {
          bubbles: true,
          detail: {
            collection_id: form.getAttribute('data-collection-id'),
            collection_handle: form.getAttribute('data-collection-handle'),
            collection_title: form.getAttribute('data-collection-title'),
            item_count: parseInt(form.getAttribute('data-item-count'), 10) || null,
            cart_item_count: cart.item_count,
            cart_total: cart.total_price / 100,
            currency: cart.currency
          }
        }));
        setTimeout(function () {
          reset(form);
        }, RESET_DELAY);
      })
      .catch(function () {
        form.classList.add('is-error');
        announce(form, labelFor(form, 'error'));
        setTimeout(function () {
          reset(form);
        }, RESET_DELAY);
      });
  });
})();
